import { handleFreeShipping } from '../global'
import { _t } from '../base'
function addCloseIconToLoginModal() {
    $('.login-widget .popup-widget-inner').prepend(`<div class="login-close"></div>`)
    $('.login-close').click(function () {
        $('body').removeClass('login-window-visible')
    })
}
function appendPriceAfterName(cartProduct) {
    const cartProductPrice = cartProduct.find('.cart-widget-product-price')

    cartProduct.find('.cart-widget-product-name').append(cartProductPrice)
}

function cartTextChange() {
    $('.cart-widget-button .btn').text(_t('cart.showCart'))
}

function getCartWidgetBottomHeight() {
    const cartWidgetBottom = $('#header .cart-widget-bottom')
    const height = cartWidgetBottom.outerHeight(true)
    document.documentElement.style.setProperty('--cart-widget-bottom-height', `${height}px`)
}

function appendExpirationDates() {
    // Get stored expiration data
    const storedData = JSON.parse(localStorage.getItem('productsExpirationData') || '[]')

    // Check each cart product
    $('.cart-widget-product').each(function () {
        const productElement = $(this)
        const productSku = productElement.attr('data-micro-sku')

        // Find matching product in stored data
        const storedProduct = storedData.find((item) => item.id === productSku)

        if (storedProduct && storedProduct.expirationDate) {
            const productNameElement = productElement.find('.cart-widget-product-name > strong')
            productNameElement.after(`
                <div class="cart-widget-product-expiration">
                    ${storedProduct.expirationDate}
                </div>
            `)
        }
    })
}

function cartWidget() {
    $('.cart-widget-product').each(function () {
        const cartProduct = $(this)
        appendPriceAfterName(cartProduct)
    })
    handleFreeShipping()
    cartTextChange()
    getCartWidgetBottomHeight()
    appendExpirationDates()
}

export function initPopupWidget() {
    addCloseIconToLoginModal()
    $('.login-widget .popup-widget-inner > h2').text(_t('login.title'))

    document.addEventListener('ShoptetDOMCartContentLoaded', () => {
        cartWidget()
    })
}
